require('./RARadialMenu.scss');
// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
// @components
const { InfoTooltip } = require('components/tooltip/tooltip');
// @ utilities
const RASuitabilityTestHelper = require('utilities/RASuitabilityTestHelper');

class RARadialMenu extends React.Component {
    constructor(props) {
        super(props);
    }

    getRadialItemClass(selectedValue, id) {
        const customClass = classNames('robo-radial-menu__petal', {
            ['robo-radial-menu__petal--selected']: selectedValue === id,
            ['robo-radial-menu__petal--selected-hover']: !this.props.disabled,
        });

        return customClass;
    }

    handleClick = e => {
        if (this.props.disabled) {
            return;
        }

        this.props.onRadialItemClick(e.currentTarget.dataset.id);
    };

    buildTooltip() {
        const { tooltipContent, onClickTooltip } = this.props;

        if (tooltipContent) {
            return (
                <div className="tooltip-wrapper" onClick={() => onClickTooltip()}>
                    <InfoTooltip text={tooltipContent} />
                </div>
            );
        }
    }

    getLabels(values) {
        let labels = [];
        values.map(value => {
            const v = value.label.title;
            const divider = v.indexOf('-');
            if (divider !== -1) {
                const label = v.slice(0, divider);
                const sublabel = v.slice(divider + 1, v.length);
                labels.push(
                    <span>
                        {label}
                        <span className="robo-radial-menu__petal__text-sublabel">
                            <br />
                            {sublabel}
                        </span>
                    </span>
                );
            } else {
                labels.push(v);
            }
        });

        return labels;
    }

    investmentList(labels) {
        const { selectedValue, values } = this.props;
        const buildCapitalClassName = this.getRadialItemClass(selectedValue, values[0].id);
        const investCapitalClassName = this.getRadialItemClass(selectedValue, values[1].id);
        const preserveCapitalClassName = this.getRadialItemClass(selectedValue, values[2].id);
        const increaseCapitalClassName = this.getRadialItemClass(selectedValue, values[3].id);
        const classes = [
            buildCapitalClassName,
            investCapitalClassName,
            preserveCapitalClassName,
            increaseCapitalClassName,
        ];
        const icons = [
            'icon-depositos',
            'icon-conservar-patrimonio',
            'icon-incremento-moderado',
            'icon-incremento-significativo',
        ];
        let list = [];
        let first;

        values.map((value, index) => {
            const type = RASuitabilityTestHelper.getTextClassByLength(labels[index]);

            const textClass = `robo-radial-menu__petal__text robo-radial-menu__petal__text-${type}`;

            list.push(
                <li key={index} className={classes[index]} onClick={this.handleClick} data-id={value.id}>
                    <span className={`robo-radial-menu__petal__icon ${icons[index]}`} />
                    <span className={textClass}>{labels[index]}</span>
                </li>
            );
        });

        first = list.shift();
        list.push(first);

        return list.map(value => {
            return value;
        });
    }

    render() {
        const { title, values } = this.props;
        const showTooltip = this.buildTooltip();
        const labels = this.getLabels(values);
        const investmentList = this.investmentList(labels);

        return (
            <div className="robo-radial-menu">
                <div className="robo-radial-menu__title">
                    {title}
                    <span>{showTooltip}</span>
                </div>
                <div className="robo-radial-menu__stem">
                    <ul className="robo-radial-menu__flower">{investmentList}</ul>
                    <div className="robo-radial-menu__stigma" />
                </div>
            </div>
        );
    }
}

RARadialMenu.propTypes = {
    onRadialItemClick: PropTypes.func.isRequired,
    selectedValue: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    values: PropTypes.array,
    tooltipContent: PropTypes.string,
};

module.exports = RARadialMenu;
